module.exports = __webpack_public_path__ + "media/images/emblems/Oberrieden-6b7a248ecf4ee3ec82270a7e77eb945e.svg";